// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#kt_theme_selection_panel {
  width: 320px !important;
  padding: 0;
}
#kt_theme_selection_panel .kt-demo-panel__head {
  padding: 20px;
  margin-bottom: 0px;
}
#kt_theme_selection_panel .kt-demo-panel__body {
  margin-right: 0px;
  padding-right: 0px;
}
#kt_theme_selection_panel .nav-tabs {
  padding-bottom: 30px;
}
#kt_theme_selection_panel .kt-tabs-line .kt-tabs__item {
  margin: 0px !important;
  padding: 20px 30px 0;
}
#kt_theme_selection_panel .kt-tabs-line.kt-tabs-line--primary.nav.nav-tabs .nav-link.active,
#kt_theme_selection_panel .kt-tabs-line.kt-tabs-line--primary a.kt-tabs__link.active {
  background: #5867dd;
  color: #fff;
  border-bottom: 0 !important;
}
#kt_theme_selection_panel .kt-tabs-line.kt-tabs-line--primary.nav.nav-tabs .nav-link.active:hover,
#kt_theme_selection_panel .kt-tabs-line.kt-tabs-line--primary a.kt-tabs__link.active:hover {
  background: #5867dd;
  color: #fff;
  border-bottom: 0 !important;
}
#kt_theme_selection_panel .kt-tabs-line.kt-tabs-line--primary.nav.nav-tabs .nav-link:hover,
#kt_theme_selection_panel .kt-tabs-line.kt-tabs-line--primary a.kt-tabs__link:hover {
  background: #ddd;
  color: #000;
  border-bottom: 0 !important;
}
#kt_theme_selection_panel .kt-tabs-line.kt-tabs-line--primary a.kt-tabs__link {
  padding: 0px;
  border: 0 !important;
  transition: 0.3s;
}
#kt_theme_selection_panel .kt-tabs-line.kt-tabs-line--primary a.kt-tabs__link img {
  width: 100%;
}
#kt_theme_selection_panel .kt-tabs-line.kt-tabs-line--primary a.kt-tabs__link .theme-name {
  display: block;
  padding: 7px;
  font-weight: bold;
  font-size: 0.9em;
}
`, "",{"version":3,"sources":["webpack://./src/app/shared/layout/theme-selection/theme-selection-panel.less"],"names":[],"mappings":"AAAA;EACI,uBAAA;EACA,UAAA;AACJ;AAHA;EAKQ,aAAA;EACA,kBAAA;AACR;AAPA;EAUQ,iBAAA;EACA,kBAAA;AAAR;AAXA;EAeQ,oBAAA;AADR;AAdA;EAoBY,sBAAA;EACA,oBAAA;AAHZ;AAMQ;;EAEI,mBAAA;EACA,WAAA;EACA,2BAAA;AAJZ;AAMY;;EACI,mBAAA;EACA,WAAA;EACA,2BAAA;AAHhB;AAOQ;;EAEI,gBAAA;EACA,WAAA;EACA,2BAAA;AALZ;AAQQ;EACI,YAAA;EACA,oBAAA;EACA,gBAAA;AANZ;AAGQ;EAMQ,WAAA;AANhB;AAAQ;EAUQ,cAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;AAPhB","sourcesContent":["#kt_theme_selection_panel {\n    width: 320px !important;\n    padding: 0;\n\n    .kt-demo-panel__head {\n        padding: 20px;\n        margin-bottom: 0px;\n    }\n\n    .kt-demo-panel__body{\n        margin-right: 0px;\n        padding-right: 0px;\n    }\n\n    .nav-tabs {\n        padding-bottom: 30px;\n    }\n\n    .kt-tabs-line {\n        .kt-tabs__item {\n            margin: 0px !important;\n            padding: 20px 30px 0;\n        }\n\n        &.kt-tabs-line--primary.nav.nav-tabs .nav-link.active,\n        &.kt-tabs-line--primary a.kt-tabs__link.active {\n            background: #5867dd;\n            color: #fff;\n            border-bottom: 0 !important;\n\n            &:hover {\n                background: #5867dd;\n                color: #fff;\n                border-bottom: 0 !important;\n            }\n        }\n\n        &.kt-tabs-line--primary.nav.nav-tabs .nav-link:hover,\n        &.kt-tabs-line--primary a.kt-tabs__link:hover {\n            background: #ddd;\n            color: #000;\n            border-bottom: 0 !important;\n        }\n\n        &.kt-tabs-line--primary a.kt-tabs__link {\n            padding: 0px;\n            border: 0 !important;\n            transition: .3s;\n\n            img {\n                width: 100%;\n            }\n\n            .theme-name {\n                display: block;\n                padding: 7px;\n                font-weight: bold;\n                font-size: .9em;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
